import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { images } from "../../../Assets/images";
import SignupProgress from "../../../Components/SignupProgress";
import Select from "react-select";
import moment from "moment-timezone";
import PhoneNumberInput from "../../../Components/PhoneNumberInput";
import storage from "../../../Assets/js/Global";
import { getData } from "country-list";
import { useNavigate } from "react-router-dom";
import VerifyOtpModal from "../../../modals/VerifyOtpModal";

const CreateAccountScreen1 = () => {
  const {
    email,
    signupData,
    updateSignupData,
    createAccountScreenOne,
    translatedLabels,
    logoUrl,
    verifyAccessCode,
    getTimeZone,
    timeZone,
    is4Life,
    fourLifeEmailOTP,
  } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const authLabel = translatedLabels?.auth;
  const isFromQR = !!storage.get("refKey");
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  // const countryOptions = (() => {
  //   const countries = getData().map((country) => ({
  //     value: country.code,
  //     label: country.name,
  //   }));
  //   const usa = countries.find(c => c.value === "US");
  //   const otherCountries = countries.filter(c => c.value !== "US").sort((a, b) => a.label.localeCompare(b.label));
  //   return usa ? [usa, ...otherCountries] : countries.sort((a, b) => a.label.localeCompare(b.label));
  // })();

  const countryOptions = (() => {
    const countries = (getData() || [])
      .filter((c) => c && c.code && c.name)
      .map((country) => ({
        value: country.code,
        label: country.name
          .replace(/\s*\(.*?\)\s*/g, " ")
          .replace(/\s+/g, " ")
          .trim(),
      }));

    const usa = countries.find((c) => c.value === "US");

    const otherCountries = countries
      .filter((c) => c.value !== "US")
      .sort((a, b) => a.label.localeCompare(b.label));

    return usa
      ? [usa, ...otherCountries]
      : countries.sort((a, b) => a.label.localeCompare(b.label));
  })();

  const TIMEZONE_MAP = {
    "Asia/Culcutta": "Asia/Kolkata",
    "Asia/Calcutta": "Asia/Kolkata",
    "America/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "America/Caracas": "America/Caracas",
    "America/La_Paz": "America/La_Paz",
    "America/Manaus": "America/Manaus",
    "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "Pacific/Samoa": "Pacific/Pago_Pago",
    "Pacific/Yap": "Pacific/Chuuk",
    "Pacific/Truk": "Pacific/Chuuk",
    "Pacific/Ponape": "Pacific/Pohnpei",
    "Etc/UTC": "Etc/UTC",
  };

  function normalizeTimezone(timezone) {
    return TIMEZONE_MAP[timezone] || timezone;
  }

  useEffect(() => {
    getTimeZone();
    const userTimeZone = moment?.tz?.guess();
    const normalizedTimeZone = normalizeTimezone(userTimeZone);
    setSelectedTimeZone(normalizedTimeZone);
    if (!signupData.time_zone) {
      updateSignupData("time_zone", normalizedTimeZone);
    }
  }, [getTimeZone, signupData.time_zone]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      const accessCode = signupData.accessCode?.trim();
      if (!accessCode) {
        setIsVerified(false);
        return;
      }

      setIsVerifying(true);
      const result = await verifyAccessCode(accessCode);
      setIsVerified(result?.status === true);
      setIsVerifying(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [signupData.accessCode, verifyAccessCode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (is4Life && signupData?.secondaryEmail && !isEmailVerified) {
      window.showToast("error", "Please verify your email");
      return;
    }
    if (!is4Life && !isFromQR && !isVerified) {
      window.showToast("error", "Please verify your access code first");
      return;
    }
    createAccountScreenOne();
  };
  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <SignupProgress currentStep={1} />
          <h3 className="mb-4 text-center">
            {authLabel?.create_new_account?.label_value || "Create new account"}
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="d-flex gap-3 align-items-center mb-2">
              <div className="form-group">
                <label className="form-label">
                  {authLabel?.first_name?.label_value || "First name"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_first_name?.label_value ||
                    "Enter firstname"
                  }
                  value={signupData?.firstName}
                  onChange={(e) =>
                    updateSignupData("firstName", e.target.value.trimStart())
                  }
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  {authLabel?.last_name?.label_value || "Last name"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_last_name?.label_value || "Enter lastname"
                  }
                  value={signupData?.lastName}
                  onChange={(e) =>
                    updateSignupData("lastName", e.target.value.trimStart())
                  }
                />
              </div>
            </div>

            {!is4Life && (
              <div className="form-group mb-2">
                <label className="form-label">
                  {authLabel?.email?.label_value || "Email"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_your_email?.label_value || "Enter e-mail"
                  }
                  value={email || signupData?.email}
                  onChange={(e) => updateSignupData("email", e.target.value)}
                  disabled
                />
              </div>
            )}

            {is4Life && (
              <div className="form-group mb-2">
                <div className="d-flex align-items-center justify-content-between">
                  <label className="form-label">
                    {authLabel?.email?.label_value || "Email"}{" "}
                  </label>
                  {isEmailVerified ? (
                    <span className="text-success fw-bold">
                      {screenLabels?.verified?.label_value || "Verified"}
                    </span>
                  ) : (
                    <span
                      className="text-primary fw-semibold"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        if (!signupData?.secondaryEmail) {
                          window.showToast("error", "Please enter email first");
                          return;
                        }
                        const success = await fourLifeEmailOTP({
                          email: signupData?.secondaryEmail,
                          module: "Signup",
                        });
                        if (success) {
                          setShowOtpModal(true);
                        }
                      }}
                    >
                      {screenLabels?.verify?.label_value || "Verify"}
                    </span>
                  )}
                </div>
                <input
                  type="email"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_your_email?.label_value || "Enter e-mail"
                  }
                  value={signupData?.secondaryEmail || ""}
                  onChange={(e) => {
                    updateSignupData("secondaryEmail", e.target.value);

                    setIsEmailVerified(false);
                  }}
                  // disabled
                />
              </div>
            )}

            <div className="mb-2">
              <div className="form-group">
                <label className="form-label">
                  {authLabel?.country?.label_value || "Country"}
                </label>

                <Select
                  options={countryOptions}
                  placeholder={
                    authLabel?.select_country?.label_value || "Select Country"
                  }
                  value={
                    selectedCountry
                      ? {
                          value: selectedCountry,
                          label: countryOptions.find(
                            (c) => c.value === selectedCountry,
                          )?.label,
                        }
                      : null
                  }
                  onChange={(option) => {
                    setSelectedCountry(option.value);
                    updateSignupData("country", option.value);
                  }}
                />
              </div>
            </div>

            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label className="form-label">
                  {authLabel?.time_zone?.label_value || "Time Zone"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <Select
                  options={timeZone?.map((item) => ({
                    value: item.zone_name,
                    label: item.zone_name,
                  }))}
                  placeholder={
                    authLabel?.select_time_zone?.label_value ||
                    "Select Timezone"
                  }
                  value={
                    selectedTimeZone
                      ? { value: selectedTimeZone, label: selectedTimeZone }
                      : null
                  }
                  onChange={(option) => {
                    setSelectedTimeZone(option.value);
                    updateSignupData("time_zone", option.value);
                  }}
                />
              </div>
            </div>

            {!is4Life && (
              <div className="form-group mb-2">
                <label className="form-label">
                  {authLabel?.phone_number?.label_value || "Phone number"}{" "}
                  <span className="text-danger">*</span>
                </label>

                <PhoneNumberInput
                  value={signupData?.phoneNumber}
                  onChange={(phoneNumber) => {
                    updateSignupData("phoneNumber", phoneNumber);
                  }}
                />
              </div>
            )}

            {!is4Life && !isFromQR && (
              <div className="form-group mb-2">
                <label className="form-label">
                  {authLabel?.access_code?.label_value || "Access code"}
                  <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_access_code?.label_value ||
                    "Enter access code"
                  }
                  value={signupData?.accessCode}
                  onChange={(e) =>
                    updateSignupData("accessCode", e.target.value.trimStart())
                  }
                />
                {isVerifying && (
                  <small className="text-info">
                    {authLabel?.verifying?.label_value ||
                      "Verifying access code..."}
                  </small>
                )}
                {!isVerifying && signupData.accessCode && (
                  <small
                    className={`${
                      isVerified ? "text-success" : "text-danger"
                    } d-block`}
                  >
                    {isVerified
                      ? authLabel?.access_code_verified?.label_value ||
                        "Access code verified successfully!"
                      : authLabel?.access_code_invalid?.label_value ||
                        "Invalid access code"}
                  </small>
                )}
              </div>
            )}

            <div className="mt-4 text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={
                  (!is4Life && !isFromQR && (!isVerified || isVerifying)) ||
                  (signupData?.secondaryEmail && !isEmailVerified)
                }
              >
                {authLabel?.next?.label_value || "Next"}
              </button>
            </div>
          </form>
        </div>
        <VerifyOtpModal
          show={showOtpModal}
          email={signupData.secondaryEmail}
          onClose={() => setShowOtpModal(false)}
          onSuccess={() => {
            setIsEmailVerified(true);
            setShowOtpModal(false);
          }}
        />
      </section>
    </>
  );
};

export default CreateAccountScreen1;
